export type ConfigurationPeriodPoint = {
  year: number | null;
  month: number | null;
};

/** แสดงจุดช่วงเวลา — ปีอย่างเดียว หรือ ปี/เดือน (YYYY/MM) */
export function formatConfigurationPeriodPoint(
  year: number | null | undefined,
  month: number | null | undefined,
): string | null {
  if (year == null) return null;
  if (month != null && month >= 1 && month <= 12) {
    return `${year}/${String(month).padStart(2, "0")}`;
  }
  return String(year);
}

/** แสดงช่วง yearFrom–yearTo (รองรับเดือน) */
export function formatConfigurationPeriodRange(
  yearFrom: number | null | undefined,
  yearTo: number | null | undefined,
  monthFrom?: number | null,
  monthTo?: number | null,
): string | null {
  const from = formatConfigurationPeriodPoint(yearFrom, monthFrom);
  const to = formatConfigurationPeriodPoint(yearTo, monthTo);
  if (!from && !to) return null;
  if (from && to) return `${from}–${to}`;
  return from ?? to;
}
